export default function NewOrderIcon({ className }: any) {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M44.3333 30.3333V43C44.3333 45.8284 44.3333 47.2426 43.4547 48.1213C42.576 49 41.1618 49 38.3333 49H17.6667C14.8382 49 13.424 49 12.5453 48.1213C11.6667 47.2426 11.6667 45.8284 11.6667 43V13C11.6667 10.1716 11.6667 8.75736 12.5453 7.87868C13.424 7 14.8382 7 17.6667 7H28"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path d="M42 7L42 21" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M49 14L35 14" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M21 30.333L35 30.333" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M21 21L30.3333 21" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      <path d="M21 39.667L30.3333 39.667" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
